import type { ImportPrizesProps } from './ImportPrizes.types'
import Box from '@mui/material/Box'
import useQueryGet from 'hooks/useQueryGet'
import RequestStatus from 'components/RequestStatus/RequestStatus'
import type { PrizeToImport } from 'types/Prize'
import { useAuthContext } from 'context/AuthContext/AuthContext'

import { Divider } from '@mui/material'
import { PrizesSignatures } from './features/prizes-signature'
import { EmbargoRequestsTable } from './features/embargo-requests-table'

export const PrizesTracker = ({ market }: ImportPrizesProps): JSX.Element => {
  const { token } = useAuthContext()

  const { data: prizes, isLoading: isPrizesLoading } = useQueryGet<PrizeToImport[]>({
    queryKey: ['all-prizes', token, market],
    endpoint: 'prize-draw',
    options: { params: { marketId: market?.id ?? '' } },
  })

  const { data: requests, isLoading: isRequestsLoading } = useQueryGet<PrizeToImport[]>({
    queryKey: ['requests', token, market],
    endpoint: `prize-draw/requests/${market?.id}`,
    queryOptions: { enabled: !!market },
  })

  if (prizes === undefined || 'error' in prizes) {
    return <RequestStatus data={prizes} isLoading={isPrizesLoading} />
  }

  if (requests === undefined || 'error' in requests) {
    return <RequestStatus data={requests} isLoading={isRequestsLoading} />
  }

  return (
    <>
      <Divider sx={{ mb: 2 }} />
      <Box flex={1} display="flex" flexDirection="column" gap={4}>
        <PrizesSignatures prizes={prizes} />
        {!!market && <EmbargoRequestsTable type="prize-draw" marketId={market.id} />}
      </Box>
    </>
  )
}
